import React from 'react';
import { track } from '../../lib/analytics';

/** If anything inside the embedded Stripe form throws, fall back to the hosted page instead of a blank screen. */
export class CheckoutErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { crashed: false }; }
  static getDerivedStateFromError() { return { crashed: true }; }
  componentDidCatch(error) {
    try { track('checkout_client_crash', { message: String(error?.message || error).slice(0, 200) }); } catch { /* ignore */ }
    this.props.onCrash?.(error);
  }
  render() { return this.state.crashed ? (this.props.fallback ?? null) : this.props.children; }
}
